import { useWrapperContext } from './Wrapper';
export function useFieldExtension() {
    return useWrapperContext();
}
export function useFormSidebarExtension() {
    return useWrapperContext();
}
/**
 * @deprecated please use {@link useFieldExtension} or {@link useFormSidebarExtension}
 */
export function useUiExtension() {
    return useWrapperContext();
}
export function useUiExtensionDialog() {
    return useWrapperContext();
}
